/**
 * @generated SignedSource<<3ac90b3d48efac7c149b3ba2456407ef>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamAdminLayoutQuery$variables = {
  teamId: string;
};
export type TeamAdminLayoutQuery$data = {
  readonly store: {
    readonly team: {
      readonly availableFeatures: ReadonlyArray<{
        readonly id: string;
        readonly isHidden: boolean;
        readonly pinnedOrder: number | null;
      }>;
      readonly " $fragmentSpreads": FragmentRefs<"TeamAdminLayout_Team">;
    } | null;
  };
};
export type TeamAdminLayoutQuery = {
  response: TeamAdminLayoutQuery$data;
  variables: TeamAdminLayoutQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "teamId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "teamId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isHidden",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pinnedOrder",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TeamAdminLayoutQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "team",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "TeamAdminLayout_Team"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "availableFeatures",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TeamAdminLayoutQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "team",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "color",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "availableFeatures",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isTeamFeature"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TodoCategoryTeam",
                        "kind": "LinkedField",
                        "name": "todoCategoryTeam",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TodoCategory",
                            "kind": "LinkedField",
                            "name": "category",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "icon",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "title",
                                "storageKey": null
                              },
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "TodoCategoryTeamFeature",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8a44f3d50160f680a4f2fb711f16a25b",
    "id": null,
    "metadata": {},
    "name": "TeamAdminLayoutQuery",
    "operationKind": "query",
    "text": "query TeamAdminLayoutQuery(\n  $teamId: ID!\n) {\n  store {\n    team(id: $teamId) {\n      ...TeamAdminLayout_Team\n      availableFeatures {\n        __typename\n        id\n        isHidden\n        pinnedOrder\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment TeamAdminLayoutFeature_TeamFeature on TeamFeature {\n  __isTeamFeature: __typename\n  id\n  __typename\n  ... on TodoCategoryTeamFeature {\n    todoCategoryTeam {\n      category {\n        icon\n        title\n        id\n      }\n      id\n    }\n  }\n}\n\nfragment TeamAdminLayout_Team on Team {\n  id\n  color\n  type\n  availableFeatures {\n    __typename\n    id\n    isHidden\n    pinnedOrder\n    ...TeamAdminLayoutFeature_TeamFeature\n  }\n}\n"
  }
};
})();

(node as any).hash = "3c1eb88762148c2b0c80082027cc5a94";

export default node;
